/**
 * Version of these terms, recorded alongside each consumer's auto-renewal consent
 * (Cal. Bus. & Prof. Code §17602(a)(6)). Bump this on ANY substantive change to the text below.
 */
export const TERMS_VERSION = "2026-10-10";
